import "react-toastify/dist/ReactToastify.css";
import VisuraButtons from "./visura-buttons";
import DragDropZone from "./dragDropZone";
import VisuraToastContainer from "./visura-toast-container";
import Flex from "@/components-library/layout/flex/flex";
function VisuraToExcelRendering() {
  return (
    <>
      <Flex
        direction={"column"}
        justify={"center"}
        align={"center"}
        wrap={"nowrap"}
      >
        <VisuraToastContainer />
        <DragDropZone />
        <Flex
          direction={"column"}
          justify={"center"}
          align={"center"}
          wrap={"nowrap"}
        >
          <VisuraButtons />
        </Flex>
      </Flex>
    </>
  );
}

export default VisuraToExcelRendering;
